import React, { Component } from 'react';
import { Col, Row, Badge } from 'react-bootstrap';

import '../Styles.css';

import RetencionStatus from './RetencionStatus';
import RetencionCloneActions from './RetencionCloneActions';
import SingleRetencionActions from './SingleRetencionActions';
import RetencionCancelacionStatus from './RetencionCancelacionStatus';

class RetencionStatusInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <>
        <Row className="mt-3 mb-2">
          <Col
            xs={12}
            sm={12}
            md={8}
            className="mb-2"
          >
            <div className="d-inline-block mr-3">
              <span className="text-muted">Ambiente:</span>
              <br />
              <Badge
                pill
                variant="warning"
              >
                {data.live !== undefined ? (data.live ? 'Producción' : 'Test') : '...'}
              </Badge>
            </div>

            <div className="d-inline-block mr-3">
              <span className="text-muted">Status:</span>
              <br />
              <RetencionStatus status={data.status} />
            </div>

            {!!data.cancelacion_status && (
              <div className="d-inline-block mr-3">
                <span className="text-muted">Status Cancelación:</span>
                <br />
                <RetencionCancelacionStatus
                  status={data.cancelacion_status}
                  cancelacion_comentario={data.cancelacion_comentario}
                />
              </div>
            )}
          </Col>
          <Col
            xs={12}
            sm={12}
            md={4}
            className="text-right mb-2 pt-2"
          >
            <SingleRetencionActions data={data} />
          </Col>
        </Row>
        <Row>
          <Col
            className="text-center"
            xs={12}
            sm={12}
            md={12}
          >
            <RetencionCloneActions data={data} />
          </Col>
        </Row>
      </>
    );
  }
}

export default RetencionStatusInfo;
